import axios from 'axios'
import { getAPIUrl } from '../API'

export type SuburbsByMunicipalityRequest = {
  municipalityId: string
}

export interface Suburb {
  id: string
  text: string
}

export const getSuburbsByMunicipality: (
  request: SuburbsByMunicipalityRequest,
) => Promise<Suburb[]> = async (request: SuburbsByMunicipalityRequest) => {
  const { data } = await axios.get(
    `${getAPIUrl()}/Common/municipality/${request.municipalityId}/suburbs`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
      },
    },
  )
  return data.data
}
